function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import { chunk } from 'lodash';
import { getStroke } from 'perfect-freehand';
import { ElementModel } from './ElementModel';
import { EditorConfig } from '../../edit/EditorConfig';
export class CurveModel extends ElementModel {
  constructor(root, scope, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "debug", false);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", false);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 4);
    if (!this.root.doc || !this.root.has('type')) {
      this.root.set('type', 'curve');
    }
    if (!this.root.doc || !this.root.has('points')) {
      this.root.set('points', new Y.Array());
    }
  }
  average(a, b) {
    return (a + b) / 2;
  }
  parsePoints(points) {
    const viewScale = this.scope.project.view.matrix.scaling.x || 1;
    const taper = this.strokeWidth * 5 / viewScale;
    const streamline = Math.min(0.7, 0.7 * viewScale);
    return getStroke(points, {
      size: this.strokeWidth,
      smoothing: 0.7,
      thinning: 0.5,
      streamline,
      simulatePressure: true,
      start: {
        taper,
        cap: true
      },
      end: {
        taper,
        cap: true
      }
    });
  }
  matrixedPoints() {
    const points = this.localPoints.length === 0 ? this.points : this.localPoints;
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    return chunk(points, 2).filter(point => point.length === 2).map(_ref => {
      let [x, y] = _ref;
      return new this.scope.Point(x, y).transform(matrix);
    }).map(point => [point.x, point.y]);
  }
  createPath(points) {
    const path = new this.scope.Path();
    const len = points.length;
    if (len < 4) {
      return path;
    }
    let control = new this.scope.Point(0, 0);
    let current = new this.scope.Point(0, 0);
    let a = points[0];
    let b = points[1];
    const c = points[2];
    current = new this.scope.Point(a[0], a[1]);
    path.moveTo(current);
    control = new this.scope.Point(b[0], b[1]);
    current = new this.scope.Point(this.average(b[0], c[0]), this.average(b[1], c[1]));
    path.quadraticCurveTo(control, current);
    for (let i = 2, max = len - 1; i < max; i++) {
      a = points[i];
      b = points[i + 1];
      control = current.multiply(2).subtract(control);
      current = new this.scope.Point(this.average(a[0], b[0]), this.average(a[1], b[1]));
      path.quadraticCurveTo(control, current);
    }
    return path;
  }
  onVectorUpdate() {
    if (!this.item) {
      return;
    }
    const matrixedPts = this.matrixedPoints();
    if (this.debug) {
      // debug 模式：直接用折线连接原始采样点，跳过 perfect-freehand
      const path = new this.scope.Path();
      for (let i = 0; i < matrixedPts.length; i++) {
        const p = new this.scope.Point(matrixedPts[i][0], matrixedPts[i][1]);
        if (i === 0) {
          path.moveTo(p);
        } else {
          path.lineTo(p);
        }
      }
      this.item.removeSegments();
      this.item.addSegments(path.segments);
      this.item.fillColor = null;
      this.item.strokeWidth = this.strokeWidth;
    } else {
      const points = this.parsePoints(matrixedPts);
      const path = this.createPath(points);
      this.item.removeSegments();
      this.item.addSegments(path.segments);
    }
  }
  createPaperItem() {
    this.item = new this.scope.Path();
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.fillColor = new this.scope.Color(this.strokeColor);
    this.onVectorUpdate();
  }
  editorConfig() {
    return new EditorConfig();
  }
  vectorKeys() {
    return ['strokeWidth'];
  }
  styleKeys() {
    return {
      include: ['strokeColor', 'strokeWidth'],
      exclude: ['dashArray', 'fillColor']
    };
  }
  liveCursorPoint() {
    const yArray = this.root.get(ElementModel.KEYS.points);
    const points = yArray.toArray();
    if (points.length < 2) {
      return null;
    }
    const len = points.length;
    const point = new this.scope.Point(points[len - 2], points[len - 1]);
    return point.transform(new this.scope.Matrix(this.pointsMatrix));
  }
  onStyleKeyUpdate(key) {
    if (!this.item) {
      return;
    }
    if (key === 'strokeColor') {
      this.item.strokeColor = new this.scope.Color(this.strokeColor);
      this.item.fillColor = new this.scope.Color(this.strokeColor);
    } else if (key === 'strokeWidth') {
      this.onVectorUpdate();
    }
  }
  subDispose() {}
}